<template>
  <el-select v-model="currentVal" :multiple="true" style="width:100%;" size="mini" :disabled="disabled">
    <el-option
      :label="item.realName"
      :value="item.id"
      :key="item.id"
      v-for="item in userList"
    ></el-option>
  </el-select>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => {
        return [];
      },
    },
    type: {
      type: String,
      default: "",
    },
    disabled:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      userList: [],
      loadingLock: false,
    };
  },
  computed: {
    currentVal: {
      get() {
        return this.value;
      },
      set(newVal) {
        this.$emit("input",newVal);
        this.$emit("change",newVal);
      },
    },
  },
  activated() {
    this.getUserList();
  },
  methods: {
    getUserList() {
      if (this.loadingLock) {
        return;
      }
      this.loadingLock = true;
      this.$http
        .get(`/sys/user/list`, { params: { type: this.type } })
        .then(({ data: res }) => {
          this.loadingLock = false;
          this.userList = res.data;
        })
        .catch((e) => {
          console.log("e", e);
          this.loadingLock = false;
        });
    },
  },
};
</script>
